"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var vue_3 = require("vue");
var SvgIcon_vue_1 = require("../SvgIcon/SvgIcon.vue");
var Modal_vue_1 = require("./Modal.vue");
var Vue3Modal_vue_1 = require("./Vue3Modal.vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'InfoModal',
    props: {
        headline: {},
        narrow: { type: Boolean },
        iconSize: { default: "4.5" },
        showIcon: { type: Boolean, default: true },
        inline: { type: Boolean, default: false },
        iconLabel: {},
        isVue3: { type: Boolean }
    },
    emits: ["opening"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var modalIsVisible = (0, vue_3.ref)(false);
        var showModal = function () {
            modalIsVisible.value = true;
            emit("opening");
        };
        var hideModal = function () { return (modalIsVisible.value = false); };
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                class: (0, vue_2.normalizeClass)(["text-left", { flex: !_ctx.inline }]),
                type: "button",
                onClick: showModal
            }, [
                (_ctx.showIcon)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgIcon_vue_1.default, {
                        key: 0,
                        "icon-name": "info",
                        class: (0, vue_2.normalizeClass)(["cursor-pointer", "h-".concat(_ctx.iconSize, " w-").concat(_ctx.iconSize)]),
                        title: _ctx.iconLabel
                    }, null, 8, ["class", "title"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (_ctx.$slots.trigger)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                        key: 1,
                        class: (0, vue_2.normalizeClass)(["cursor-pointer font-medium underline", { 'm-down:block': !_ctx.inline }])
                    }, [
                        (0, vue_2.renderSlot)(_ctx.$slots, "trigger")
                    ], 2))
                    : (0, vue_2.createCommentVNode)("", true),
                (modalIsVisible.value && !_ctx.isVue3)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                        key: 2,
                        class: "cursor-default",
                        headline: _ctx.headline,
                        narrow: _ctx.narrow,
                        onClosed: hideModal
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.renderSlot)(_ctx.$slots, "default")
                        ]; }),
                        _: 3
                    }, 8, ["headline", "narrow"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (modalIsVisible.value && _ctx.isVue3)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Vue3Modal_vue_1.default, {
                        key: 3,
                        class: "cursor-default",
                        headline: _ctx.headline,
                        narrow: _ctx.narrow,
                        onClosed: hideModal
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.renderSlot)(_ctx.$slots, "default")
                        ]; }),
                        _: 3
                    }, 8, ["headline", "narrow"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 2));
        };
    }
});
